// we don't do any error checking on props, we assume the caller has done that already
// color (string), width (number of pixels), and height (number of pixels) should always be specified
const Icon = (props) => (
	<>
		<svg
			width={props.width}
			height={props.height}
			viewBox="0 0 24 24"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
		>
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M23 1H1V23H23V1ZM9.46265 20.4062V3.66193H7.11606V20.4062H9.46265ZM16.8777 20.4062V3.66193H14.5311V20.4062H16.8777Z"
				fill={props.color}
			/>
		</svg>
	</>
);

export default Icon;
